export default function (len) {
  const list = [];
  for (let i = 0; i < len; i++) {
    list.push(null);
  }
  return list;
}
